import React from "react";
import "./AppLoader.scss";

const AppLoader = () => {
    return (
        <div className="app-loader">
            <div className="spinner"></div>
            <div className="loading-text">Loading...</div>
        </div>
    );
};

export default React.memo(AppLoader);
